import { CurrencyPipe, DatePipe } from '@angular/common';
import { Column, GridRow } from '@shared';

class ChangesetModifierCodes {
  id: string = '';
  priceTierId: string = '';

  @Column({
    title: 'Tier',
    field: 'priceTierName',
    order: 0.1,
    width: 150,
    filterable: true,
    filterType: 'text',
    sortable: true,
    visibleInQuickView: true,
    hidden: true,
  })
  priceTierName: string = '';

  @Column({
    title: 'Brink ID',
    field: 'parItemId',
    order: 0.7,
    width: 90,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  parItemId: string = '';

  restaurantId: string = '';

  @Column({
    title: 'Restaurant',
    field: 'restaurantName',
    order: 0,
    width: 100,
    sortable: true,
    filterable: true,
    filterType: 'text',
    visibleInQuickView: true,
  })
  restaurantName: string = '';

  @Column({
    title: 'Product',
    field: 'itemName',
    order: 0.6,
    width: 150,
    filterable: true,
    filterType: 'text',
    type: 'string',
    fixed: true,
    align: 'left',
    sortable: true,
    visibleInQuickView: true,
  })
  itemName: string = '';

  @Column({
      title: 'Current Price',
      field: 'itemPrice',
      order: 1.1,
      width: 80,
      pipeToken: CurrencyPipe,
      filterable: true,
      filterType: 'numeric',
      type: 'number',
      fixed: true,
      sortable: true,
      visibleInQuickView: true,
    })
  itemPrice: number = 0;


  
  @Column({
    title: 'New Price',
    field: 'newPrice',
    order: 1.2,
    pipeToken: CurrencyPipe,
    width: 80,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  newPrice: number = 0;


  @Column({
    title: 'Scheduled For',
    field: 'scheduledDate',
    order: 0.4,
    width: 100,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd HH:mm'],
    filterable: true,
    filterType: 'date',
    type: 'string',
    sortable: true,
    hidden: true,
    visibleInQuickView: true,
  })
  scheduledDate: Date | null = null;

  @Column({
    title: 'Created On',
    field: 'createdOn',
    hidden: true,
    order: 8,
    width: 100,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd HH:mm'],
    filterable: true,
    filterType: 'date',
    type: 'string',
    sortable: true,
    visibleInQuickView: true,
  })
  createdOn: Date | null = null;

  @Column({
    title: 'Sent On',
    field: 'transmittedOn',
    order: 0.5,
    width: 80,
    filterable: true,
    filterType: 'date',
    type: 'string',
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd HH:mm'],
    sortable: true,
    visibleInQuickView: true,
  })
  transmittedOn: Date | null = null;

  @Column({
    title: 'Sent On (Store Local Time)',
    field: 'restaurantTimestamp',
    order: 0.5,
    width: 80,
    filterable: true,
    filterType: 'date',
    type: 'string',
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd HH:mm'],
    sortable: true,
    visibleInQuickView: true,
  })
  restaurantTimestamp: Date | null = null;

  restaurantTimezone: string | null = null;

  @Column({
    title: 'Sent to PAR',
    field: 'transmitStatus',
    order: 0.1,
    width: 80,
    filterable: true,
    filterType: 'multiselect',
    filterOptions: [
      { name: 'Pending', value: 'Pending' },
      { name: 'Scheduled', value: 'Scheduled' },
      { name: 'Success', value: 'Success' },
      { name: 'Failed', value: 'Failed' },
      { name: 'Canceled', value: 'Canceled' },
    ],
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  transmitStatus: string = '';

  @Column({
    title: 'Confirmed',
    field: 'dataStatus',
    order: 0.2,
    width: 80,
    filterable: true,
    filterType: 'multiselect',
    filterOptions: [
      { name: 'Pending', value: 'Pending' },
      { name: 'Success', value: 'Success' },
      { name: 'Canceled', value: 'Canceled' },
    ],
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  dataStatus: string = '';

  type: string = '';

  @Column({
    title: 'Created By',
    field: 'createdBy',
    order: 8,
    width: 80,
    filterable: true,
    filterType: 'text',
    hidden: true,
    type: 'string',
  })
  createdBy: string | null = null;

  @Column({
    title: 'Modifier Code',
    field: 'modifierCode',
    order: 0.65,
    width: 80,
    filterable: true,
    filterType: 'text',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  modifierCode: string | null = null;

  constructor(idOrChangeset?: string | Partial<ChangesetModifierCodes>) {
    if (typeof idOrChangeset === 'string') {
      this.id = idOrChangeset;
    } else if (idOrChangeset) {
      Object.assign(this, idOrChangeset);
    }
  }
}
export class GridRowChangesetModifierCodes extends GridRow(ChangesetModifierCodes) {}
